import { render, staticRenderFns } from "./FamiliariComponent.vue?vue&type=template&id=213942f8&"
import script from "./FamiliariComponent.vue?vue&type=script&lang=js&"
export * from "./FamiliariComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports